<div class="pageheader">
  <div class="page-title">
    <h1>User groups</h1>
    <div class="btn-toolbar">
      <div class="btn-group">
        <app-change-log-link *bizPermissionRequired="'UserGroup_Action_ShowLog'" [title]="'User groups log'">
          <app-change-log-link-entity type="UserGroup"></app-change-log-link-entity>
        </app-change-log-link>
      </div>
    </div>
  </div>
</div>

<dx-data-grid biz-grid [selection]='{ mode: "none" }' [dataSource]='userGroups()' [bizAutoWidth]="false"
  (onRowInserting)="onGroupInserting($event)" (onRowUpdating)="onGroupUpdating($event)"
  (onRowRemoving)="onGroupRemoving($event)" (onEditingStart)="onEditingStart($event)" [masterDetail]="{
        enabled: true,
        template: 'rolesMasterTemplate'
    }">

  <dxo-editing mode="popup" [allowUpdating]="editAllowed()" [allowAdding]="createAllowed()"
    [allowDeleting]="deleteAllowed()">
    <dxo-popup title="Group" [showTitle]="true"></dxo-popup>
  </dxo-editing>

  <dxo-column-fixing [enabled]="true"></dxo-column-fixing>

  <dxi-column dataField="Name" caption="Name" dataType="string" [validationRules]="[{ type: 'required' }]"></dxi-column>
  <dxi-column dataField="Description" caption="Description" dataType="string"
    [validationRules]="[{ type: 'required' }]"></dxi-column>
  <dxi-column dataField="DomainAccount" caption="Domain Account" dataType="string"></dxi-column>

  <dxi-column dataField="Roles" caption="Roles" cellTemplate="rolesTemplate" editCellTemplate="rolesEditTemplate"
    [calculateFilterExpression]="calculateArrayRolesFilterExpression" [calculateSortValue]="calculateSortValue">
    <dxo-header-filter [dataSource]="getRolesHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column dataField="DataGroups" caption="Data groups" cellTemplate="dataGroupTemplate"
    editCellTemplate="dataGroupsEditTemplate" [calculateFilterExpression]="calculateArrayDataGroupsFilterExpression"
    [calculateSortValue]="calculateSortValueDataGroups">
    <dxo-header-filter [dataSource]="getDataGroupsHeaderFilterData()"></dxo-header-filter>
  </dxi-column>

  <dxi-column biz-grid-user dataField="CreatedBy" caption="Created By" [visible]="false">
    <dxo-header-filter
      [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(userGroups(), 'CreatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="CreatedDate" caption="Created Date" [visible]="false"
    format="dateTime"></dxi-column>
  <dxi-column biz-grid-user dataField="UpdatedBy" caption="Modified By" [visible]="false">
    <dxo-header-filter
      [dataSource]="bizGridFiltervalues.getUserFilterData(bizGridFiltervalues.getPropertyValues(userGroups(), 'UpdatedBy'))"></dxo-header-filter>
  </dxi-column>
  <dxi-column biz-grid-date dataField="UpdatedDate" caption="Modified Date" [visible]="false"
    format="dateTime"></dxi-column>

  <dxi-column type="buttons">
    <dxi-button name="edit"></dxi-button>
    <dxi-button name="delete"></dxi-button>
    <dxi-button text="Show Log" template="logTemplate" [visible]="showLogAllowed()">
    </dxi-button>
  </dxi-column>

  <ng-container *dxTemplate="let cell of 'logTemplate'">
    <app-change-log-link *bizPermissionRequired="'UserGroup_Action_ShowLog'" [title]="'Log for ' + cell.data.Name"
      [showIcon]="false" classNames="dx-link">
      <app-change-log-link-entity type="UserGroup" [id]="cell.data.Id"></app-change-log-link-entity>
    </app-change-log-link>
  </ng-container>

  <div *dxTemplate="let cell of 'rolesMasterTemplate'">
    <div class="row">
      <div class="col-md-6">
        <label>Roles:</label>
        <dx-data-grid [dataSource]='cell.data.Roles' [columnAutoWidth]='true'>
          <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
          <dxi-column dataField="RoleName" caption="Role" dataType="string" sortOrder="asc"></dxi-column>
        </dx-data-grid>
      </div>
      <div class="col-md-6">
        <label>Data groups:</label>
        <dx-data-grid [dataSource]='cell.data.DataGroups' [columnAutoWidth]='true'>
          <dxo-search-panel [visible]="true" [width]="240" placeholder="Search..."></dxo-search-panel>
          <dxi-column dataField="Name" caption="Data group" dataType="string" sortOrder="asc"></dxi-column>
        </dx-data-grid>
      </div>
    </div>
  </div>

  <div *dxTemplate="let cell of 'rolesTemplate'">
    @for (role of cell.data.Roles; track role.RoleId; let isLast = $last) {
    <span [title]="cell.data.RolesTooltip">{{role.RoleName}} {{isLast ? '' : ', '}}</span>
    }
  </div>
  <ng-container *dxTemplate="let cell of 'rolesEditTemplate'">
    <dx-tag-box [dataSource]="availableRoles()" [value]="getRoleIds(cell.value)" displayExpr="RoleName"
      valueExpr="RoleId" placeholder="Select roles..." [showSelectionControls]="true"
      (onValueChanged)="onRolesValueChanged(cell, $event)">
    </dx-tag-box>
  </ng-container>

  <div *dxTemplate="let cell of 'dataGroupTemplate'">
    @for (dataGroup of cell.data.DataGroups; track dataGroup.Id; let isLast = $last) {
    <span [title]="cell.data.DataGroupsTooltip">{{dataGroup.Name}} {{isLast ? '' : ', '}}</span>
    }
  </div>
  <ng-container *dxTemplate="let cell of 'dataGroupsEditTemplate'">
    <dx-tag-box [dataSource]="availableDataGroups()" [value]="getDataGroupIds(cell.value)" displayExpr="Name"
      valueExpr="Id" placeholder="Select data groups..." [showSelectionControls]="true"
      (onValueChanged)="onDataGroupsValueChanged(cell, $event)">
    </dx-tag-box>
  </ng-container>
</dx-data-grid>